/**
 * @param {Record<string, any>} obj
 * @returns {FormData}
 */
export default function encodeFormData(obj) {
  const formData = new FormData();

  Object.entries(obj).forEach(([key, value]) => {
    if (key === "data" || key === "meta") {
      try {
        formData.append(key, JSON.stringify(value));
      } catch (e) {
        console.warn(`Failed to stringify ${key}:`, e);
        formData.append(key, "");
      }
    } else if (value || value === null) {
      formData.append(key, value);
    }
  });

  return formData;
}
